import { api as weblinksApi } from './auto-generated/weblinks'

weblinksApi.enhanceEndpoints({
  endpoints: {
    weblinksCreateWeblink: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled
          dispatch(
            weblinksApi.util.updateQueryData(
              'weblinksGetWeblinks',
              { query: '' },
              (draftWeblinks) => {
                draftWeblinks.push(response.data)
              },
            ),
          )
        } catch {}
      },
    },
    weblinksDeleteWeblink: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          weblinksApi.util.updateQueryData(
            'weblinksGetWeblinks',
            { query: '' },
            (draftWeblinks) => {
              return draftWeblinks.filter((e) => e.id !== args.weblinkId)
            },
          ),
        )
        try {
          await queryFulfilled
        } catch {
          patchResult.undo()
        }
      },
    },
    weblinksUpdateWeblinks: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          weblinksApi.util.updateQueryData(
            'weblinksGetWeblinks',
            { query: '' },
            (draftWeblinks) => {
              draftWeblinks.map((e) => {
                if (e.id === args.weblinkId) {
                  e.title = args.updateWeblinkRequest.title
                  e.link = args.updateWeblinkRequest.link
                  e.tags = args.updateWeblinkRequest.tags
                }
              })
            },
          ),
        )
        try {
          await queryFulfilled
        } catch {
          patchResult.undo()
        }
      },
    },
  },
})

export { weblinksApi }
